import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AuthService } from '@klickdata/core/auth';
import { MobileService } from '@klickdata/core/mobile';
import { ResourceSelectComponent } from '@klickdata/shared-components/src/selection-handler/resources-assign/resource-select/resource-select.component';
import { ResourceSelectDatatableService } from 'apps/klickdata/src/app/master/customers/customer-manager/customer-manager-resources/resource-select-datatable.service';

@Component({
    selector: 'app-scoped-resource-select-manager',
    templateUrl: './scoped-resource-select-manager.component.html',
    styleUrls: ['./scoped-resource-select-manager.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [ResourceSelectDatatableService],
})
export class ScopedResourceSelectManagerComponent extends ResourceSelectComponent {
    constructor(
        public datatableService: ResourceSelectDatatableService,
        protected mobileService: MobileService,
        protected auth: AuthService
    ) {
        super(datatableService, mobileService, auth);
    }

    detectIdKeyValueChange() {
        this.refresh(this.customer_id);
    }
    public refresh(id?: any): void {
        const filters: Array<{ property: string; items: (string | number)[] }> = [
            { property: 'scope', items: [this.scope_id] },
        ];
        // const filters = [{ property: 'scope', items: [this.scope_id] }];
        if (this.referenceFilter) {
            filters.push({ property: this.referenceFilter, items: [this.referencePropertyValue ?? id] });
        }
        if (!!this.eager?.length) {
            filters.push({ property: 'eager', items: this.eager });
        }
        this.filter?.createOrUpdateWithoutEmitFilter(filters);
    }
}
